var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-tooltip"},[(_vm.text)?_c('el-tooltip',{attrs:{"content":_vm.text,"disabled":!_vm.showTooltip,"placement":"top","effect":_vm.effect}},[_c('div',{staticClass:"ellipsis-text",style:({ maxWidth: _vm.maxWidth }),on:{"mouseenter":_vm.handleMouseEnter}},[_vm._v(" "+_vm._s(_vm.text)+" ")])]):_c('div',[_vm._v("-")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }